import { render } from "./InsuranceTypeAdd.vue?vue&type=template&id=64087945&scoped=true"
import script from "./InsuranceTypeAdd.vue?vue&type=script&lang=js"
export * from "./InsuranceTypeAdd.vue?vue&type=script&lang=js"

import "./InsuranceTypeAdd.vue?vue&type=style&index=0&id=64087945&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64087945"]])

export default __exports__